module.exports = __webpack_public_path__ + "img/raca.0ef49072.svg";